import { NgModule } from '@angular/core';
import {provideRouter, RouterModule, Routes, withComponentInputBinding} from '@angular/router';
import {LayoutComponent} from "./shared/common/layout/layout.component";
import {NotFoundComponent} from "./shared/common/layout/errors/not-found/not-found.component";
import {ProjectNotActiveComponent} from "./shared/common/layout/errors/project-not-active/project-not-active.component";
import {LeadGenerationComponent} from "./steps/lead-generation/lead-generation.component";
import {IndexComponent} from "./shared/common/index/index.component";
import {ErrorsService} from "./shared/services/errors.service";
import {ContractComponent} from "./steps/contract/contract.component";
import {ActComponent} from "./steps/act/act.component";
import {ValuesInDisputeComponent} from "./steps/values-in-dispute/values-in-dispute.component";
import {DataGateComponent} from "./steps/data-gate/data-gate.component";
import {DemoComponent} from "./shared/demo/demo.component";
import {
  ThankYouLeadGenerationComponent
} from "./shared/common/thank-you/thank-you-lead-generation/thank-you-lead-generation.component";
import {ThankYouDatagateComponent} from "./shared/common/thank-you/thank-you-datagate/thank-you-datagate.component";
import {TitleResolverService} from "./shared/services/title-resolver.service";
import {ThankYouContractComponent} from "./shared/common/thank-you/thank-you-contract/thank-you-contract.component";
import {ThankYouActComponent} from "./shared/common/thank-you/thank-you-act/thank-you-act.component";
import {GenerateTokensComponent} from "./shared/demo/generate-tokens/generate-tokens.component";

const routes: Routes = [
  {
    path:'thank-you-1',
    component: ThankYouLeadGenerationComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path:'demo',
        component: DemoComponent
      },
      {
        path:'tokengenerator/:projectShortname',
        component: GenerateTokensComponent
      },
      {
        path: 'registration/:projectShortname/step1',
        component: LeadGenerationComponent
      },
      {
        path: 'registration/:projectShortname/step3/:tokenIdentifier',
        component: ValuesInDisputeComponent
      },
      {
        path: 'registration/:projectShortname/step2/:tokenIdentifier',
        component: ActComponent
      },
      {
        path: 'registration/:projectShortname/step4/:tokenIdentifier',
        component: ContractComponent
      },
      {
        path: 'registration/datagate/:tokenIdentifier',
        component: DataGateComponent
      },
      {
        path: 'registration/:projectShortname/thank-you-1',
        component: ThankYouLeadGenerationComponent
      },
      {
        path: 'registration/:projectShortname/thank-you-2',
        component: ThankYouContractComponent
      },
      {
        path: 'registration/:projectShortname/thank-you-3',
        component: ThankYouActComponent
      },
      {
        path: 'registration/datagate/thank-you/:tokenIdentifier',
        component: ThankYouDatagateComponent
      },
      {
        path: '404',
        component: NotFoundComponent
      },
      {
        path: 'project-not-active',
        component: ProjectNotActiveComponent
      },
      {
        path: '',
        component: IndexComponent
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule],
  providers: [
    provideRouter(routes, withComponentInputBinding())
  ]
})
export class AppRoutingModule { }
